module.exports = __webpack_public_path__ + "img/4.da88eec7.jpg";